import React, { Component } from 'react'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'

import { Layout, Container, PageTitle } from 'src/components/Layout'
import Confirmation from 'src/modals/Confirmation/index'
import List from 'src/components/List'
import { Loader } from 'src/components/Loader'
import Disclaimer from 'src/modals/Disclaimer'
import ThankYou from 'src/modals/ThankYou/index'
import intlMessagesApp from 'src/modules/App/translations'
import withToast from 'src/components/Toast'
import { Text } from '@chakra-ui/react'

import intlMessages from '../../translations'

class RemoveDriver extends Component {
  state = {
    showConfirmation: false,
    showDisclaimer: false,
    confirmed: false,
    error: false,
  }

  componentDidUpdate(prevProps) {
    const { successful, submitting, toast, intl } = this.props

    if (!submitting && prevProps.submitting && successful) {
      this.setState({
        showDisclaimer: false,
        showConfirmation: false,
        confirmed: true,
      })
    }

    if (!submitting && prevProps.submitting && !successful) {
      this.setState({
        showDisclaimer: false,
        showConfirmation: false,
        error: true,
      })
      toast({
        title: intl.formatMessage(intlMessagesApp.appErrorTitle),
        status: 'error',
      })
    }
  }

  componentDidMount() {
    const { getDocumentDrivers, selectedDocument } = this.props

    if (selectedDocument && selectedDocument.hasOwnProperty('policyNumber')) {
      getDocumentDrivers(selectedDocument.policyNumber)
    }
  }

  handleCloseConfirmation = () => {
    this.setState({
      showConfirmation: false,
    })
  }

  getDriversList = drivers => {
    return drivers.reduce((result, driver) => {
      return [
        ...result,
        {
          leftIcon: ['far', 'steering-wheel'],
          name: `${driver.firstName} ${driver.lastName}`,
          rightIcon: 'right',
          hideArrow: true,
          onClick: () => this.handleClick(driver),
          driver,
        },
      ]
    }, [])
  }

  handleClick = driver => {
    this.props.setDocumentDriver(driver)
    this.setState({
      showConfirmation: true,
    })
  }

  renderConfirmationContent = driver => {
    if (!driver) return
    return (
      <Text>
        <FormattedHTMLMessage
          id='app.document.removeDriver.confirm2'
          defaultMessage='You would like to remove <br /> <b>{firstName} {lastName}</b> <br /> as a driver from this vehicle'
          values={{
            firstName: driver.firstName,
            lastName: driver.lastName,
          }}
        />
      </Text>
    )
  }

  handleConfirmation = () => {
    this.setState({
      showDisclaimer: true,
      showConfirmation: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { driver, document, removeDocumentDriver } = this.props

    removeDocumentDriver(driver.id, document.id, document.type)
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleCloseThankYouModal = () => {
    const { history } = this.props
    this.setState({
      confirmed: false,
    })
    history.push('/documents/item')
  }

  renderThankYouContent = driver => {
    const { countryIsoCode } = this.props

    if (!driver) return

    return (
      <Text>
        {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
          <FormattedHTMLMessage
            id='app.document.removeDriver.thankYouBodyUS'
            defaultMessage='Your request to remove <br /> <b>{firstName} {lastName}</b> <br /> as a driver on this vehicle has been sent to your agent'
            values={{
              firstName: driver.firstName,
              lastName: driver.lastName,
            }}
          />
        ) : (
          <FormattedHTMLMessage
            id='app.document.removeDriver.thankYouBody'
            defaultMessage='Your request to remove <br /> <b>{firstName} {lastName}<b> <br /> as a driver on this vehicle has been sent to your broker'
            values={{
              firstName: driver.firstName,
              lastName: driver.lastName,
            }}
          />
        )}
      </Text>
    )
  }

  render() {
    const { intl, loading, features, submitting, driver, drivers } = this.props
    const { showDisclaimer, confirmed, showConfirmation } = this.state

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    return (
      <Layout>
        <PageTitle
          title={intl.formatMessage(intlMessages.documentRemoveDriverHeadline)}
          subtitle={title}
        />

        <Container>
          {loading ? (
            <Loader styleVariation='staticWithHeight' addDesktopBackgroundColor={true} />
          ) : (
            <List
              items={this.getDriversList(drivers)}
              isColumn={true}
              noMargin={true}
              onClick={this.handleClick}
              noResultsMessage={intl.formatMessage(intlMessages.documentRemoveDriverNoResults)}
            />
          )}

          <ThankYou
            visible={confirmed}
            onClose={this.handleCloseThankYouModal}
            renderContent={this.renderThankYouContent(driver)}
          />

          <Confirmation
            visible={showConfirmation}
            onClose={this.handleCloseConfirmation}
            renderContent={this.renderConfirmationContent(driver)}
            onConfirm={this.handleConfirmation}
          />

          {!confirmed ? (
            <Disclaimer
              visible={showDisclaimer}
              loading={submitting}
              onClose={this.handleCloseDisclaimer}
              onSubmit={this.handleSubmitDisclaimer}
            />
          ) : null}
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(injectIntl(withToast(RemoveDriver)))
